import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

import { EasFormGroup } from '@fry/components/common/easform';
import { NotifyService } from '@fry/lib/utils';
import { CanComponentDeactivate } from '@fry/components/common/form';
import { VenueEditForm } from '@fry/booking/lib/venues/venue-edit.form';
import { Venue } from '@fry/booking/lib';


@Component({
    selector: 'eas-venue-edit',
    templateUrl: './venue-edit.component.html',
    providers: [
        VenueEditForm
    ],
    standalone: false
})
export class VenueEditComponent implements OnInit, CanComponentDeactivate {

  public venue: Venue;
  public formData$: Observable<FormData>;
  public easFormGroup$: Observable<EasFormGroup>;

  constructor(
    private editForm: VenueEditForm,
    private route: ActivatedRoute,
    private notify: NotifyService
  ) { }

  ngOnInit() {
    this.route.data.subscribe(
      data => {
        this.venue = data.venue;
        this.easFormGroup$ = this.editForm.init(this.venue);
      });
  }

  onSubmit() {
    this.editForm.submit(this.venue).subscribe(
      data => {
        this.venue = data;
        this.notify.success($localize `Venue successfully saved`);
      },
      error => this.notify.error(error)
    );
  }

  canSafelyDeactivate() {
    return this.editForm.pristine;
  }
}
